import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Onboarding from './Onboarding';

const OnboardingRouter = (props) => {
  return (
    <Router>
      <Onboarding {...props} />
    </Router>
  );
};

export default OnboardingRouter;
